// Business type vocabulary. Pairs with BusinessType (a string union) declared
// in @prototypical/types. The id of every BusinessTypeDef must match a
// member of that union.
export const BUSINESS_TYPES = [
    { id: "restaurant", label: "Restaurant or Cafe", hint: "menu, hours, ordering" },
    { id: "retail", label: "Shop or Store", hint: "products, hours, online sales" },
    { id: "service", label: "Service Business", hint: "HVAC, plumbing, cleaning, landscaping…" },
    { id: "professional", label: "Professional Services", hint: "lawyer, accountant, consultant" },
    { id: "health", label: "Health & Wellness", hint: "salon, fitness, dental, therapy" },
    { id: "creative", label: "Creative or Portfolio", hint: "artist, photographer, designer" },
    { id: "other", label: "Something else", hint: "tell us in the next step" },
];
export function getBusinessType(id) {
    return BUSINESS_TYPES.find((b) => b.id === id);
}
